import { useEffect, useRef } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const TESTIMONIALS = [
  {
    name:   'Raju Sharma',
    role:   'Owner, Raju Bullet Wale',
    text:   'The new system feels simple for customers and serious on the business side. Bookings, billing, and follow-ups finally move together.',
    avatar: 'RS',
  },
  {
    name:   'Mohit Dhakad',
    role:   'Proprietor, Mohit Traders',
    text:   'Our online presence went from basic to polished. The cleaner layout and product flow make the whole business look more credible.',
    avatar: 'MD',
  },
  {
    name:   'Priya Malviya',
    role:   'Founder, PM Boutique',
    text:   'The team understood both the brand and the conversion side. It looks premium now, but it also guides people toward action.',
    avatar: 'PM',
  },
];

export default function Testimonials() {
  const ref = useRef(null);

  useEffect(() => {
    gsap.from(ref.current.querySelector('.testi-head'), {
      opacity: 0, y: 30, duration: 0.7, ease: 'power3.out',
      immediateRender: false,
      scrollTrigger: { trigger: ref.current, start: 'top 80%' },
    });
    gsap.from(ref.current.querySelectorAll('.testi-card'), {
      opacity: 0, y: 44, stagger: 0.14, duration: 0.7, ease: 'power3.out',
      immediateRender: false,
      scrollTrigger: { trigger: ref.current, start: 'top 72%' },
    });

    // Ensures ScrollTrigger calculates correct positions after mount/refresh.
    ScrollTrigger.refresh();
  }, []);

  return (
    <section ref={ref} className="section">
      <div className="container">
        <div className="section-heading testi-head">
          <p className="eyebrow">Client Voices</p>
          <h2 className="heading">Trust is built in the details.</h2>
        </div>

        <div className="testimonials-grid">
          {TESTIMONIALS.map((t) => (
            <div key={t.name} className="testimonial-card testi-card">
              <div style={{ fontSize: 26, color: 'var(--accent)', opacity: 0.6 }}>
                ❝
              </div>
              <p>{t.text}</p>
              <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                <div className="testimonial-avatar">{t.avatar}</div>
                <div>
                  <div className="testimonial-person">{t.name}</div>
                  <div className="testimonial-role">{t.role}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
